/**
 * Formatters
 * Text and data formatting utilities
 */
export class Formatters {
    /**
     * Format time ago
     * @param {Date|number} timestamp
     * @returns {string}
     */
    static timeAgo(timestamp) {
        const date = timestamp instanceof Date ? timestamp : new Date(timestamp);
        const ageMinutes = Math.floor((Date.now() - date.getTime()) / 1000 / 60);

        if (ageMinutes < 60) {
            return `${ageMinutes} minute${ageMinutes !== 1 ? 's' : ''} ago`;
        }

        const ageHours = Math.floor(ageMinutes / 60);
        return `${ageHours} hour${ageHours !== 1 ? 's' : ''} ago`;
    }

    /**
     * Truncate text
     */
    static truncate(text, maxLength) {
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength - 3) + '...';
    }

    /**
     * Escape HTML
     */
    static escapeHTML(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    /**
     * Parse markdown-like bold
     */
    static parseBold(text) {
        return text.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    }
}
